import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoWhatInBox from 'eco-design/sections/eco-what-in-box';
import styles from './index.module.scss';
import EfSection from '@elem/ui/ef-section';

const JM: React.FC = () => {
    const { t } = useLang('delta3series');
    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724664073834/dd2.png',
            title: t('M_item1_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725500461530/AC_cable_na.png',
            title: t('M_item2_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724663816399/a2.png',
            title: t('M_item3_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724663816161/a3.png',
            title: t('M_item4_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724663816618/a4.png',
            title: t('M_item5_title'),
        },
    ];

    return (
        <div className={styles.comp} id="d3-M">
            <EcoSpace />
            <EfSection title={t('M_title')} />
            <EcoSpaceSmall />
            <EcoWhatInBox items={items} />
        </div>
    );
};

export default JM;
